import urls from '@/utils/urls/urls'
import React from 'react'

const ServicesCard = ({ data }: { data: any }) => {
    // const data = [];
    return (
        <>
            {
                data?.length > 0 ?
                    <div className="process-wrap wow fadeInUp" data-wow-delay=".25s">
                        <div className="row g-4 d-flex justify-content-center">
                            {
                                data?.map((dataOne: any, index: number) =>
                                    <div className="col-md-12 col-lg-12" key={index}>
                                        <ServiceCard dataOne={dataOne} index={index} />
                                    </div>
                                )
                            }


                            {/* <div className="col-md-6 col-lg-4 ">
                    <div className="process-item">
                        <span className="count">Step - 01</span>
                        <div className="icon">
                            <img src="../assets/img/icon/hybrid.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Choose Service</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="process-item">
                        <span className="count">Step - 02</span>
                        <div className="icon">
                            <img src="../assets/img/icon/consult.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Free Consultant</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="process-item">
                        <span className="count">Step - 03</span>
                        <div className="icon">
                            <img src="../assets/img/icon/plan.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Planing &amp; Analysis</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="process-item">
                        <span className="count">Step - 04</span>
                        <div className="icon">
                            <img src="../assets/img/icon/install-3.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Mechine Installation</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div> */}
                        </div>
                    </div>
                    : <span>No Data Found</span>
            }
        </>

    )
}

const ServiceCard = ({ dataOne, index }: { dataOne: any, index: number }) => {
    return (
        <div className="process-item relative"
            style={{
                width: '100%',
                // height: '500px',
                // objectFit: 'cover',

            }}
        >
            {/* <span className="count"># {index + 1}</span> */}
            <div className=""
            >
                {/* <img src="../assets/img/icon/hybrid.svg" alt="" /> */}
                <img src={`${urls.image}${dataOne?.image}`} alt=""
                    style={{
                        // position: 'absolute',
                        // right: '0px',
                        width: '100%',
                        height: '500px',
                        border: '1px',
                        borderRadius: '10px',
                        objectFit: 'cover',
                        display: 'inline',
                    }}
                />
                {/* <i className={`${dataOne?.icon_class} bi bi-arrow-down-left-circle icon-size-lg`}></i> */}
            </div>
            <div className="content"
                style={{
                    borderRadius: '0 300px 0 0 '
                }}>
                <h4>{dataOne?.name}</h4>
                <p>
                    <div dangerouslySetInnerHTML={{ __html: dataOne?.description }} />
                </p>
            </div>
        </div>
    )
}


export default ServicesCard
